import { getOptionsFromEnumAndRecord } from '../utils';
import {
  AborCities,
  AborCitiesLabel,
  CtxCities,
  CtxCitiesLabel,
  HarCities,
  HarCitiesLabel,
  SaborCities,
  SaborCitiesLabel,
  DfwCities,
  DfwCitiesLabel,
  AmarilloCities,
  AmarilloCitiesLabel
} from './cities';

export enum MarketCode {
  DFW = 'dfw',
  Sabor = 'sanAntonio',
  CTX = 'ctx',
  Austin = 'austin',
  Houston = 'houston',
  Amarillo = 'amarillo'
}

export const MarketCodeLabel = new Map<MarketCode, string>([
  [MarketCode.DFW, 'DFW'],
  [MarketCode.Sabor, 'San Antonio'],
  [MarketCode.CTX, 'CTX'],
  [MarketCode.Austin, 'Austin'],
  [MarketCode.Houston, 'Houston'],
  [MarketCode.Amarillo, 'Amarillo']
]);

export const MarketCities = new Map<MarketCode, Record<string, string>>([
  [MarketCode.Sabor, getOptionsFromEnumAndRecord(Object.values(SaborCities), SaborCitiesLabel)],
  [MarketCode.CTX, getOptionsFromEnumAndRecord(Object.values(CtxCities), CtxCitiesLabel)],
  [MarketCode.Austin, getOptionsFromEnumAndRecord(Object.values(AborCities), AborCitiesLabel)],
  [MarketCode.Houston, getOptionsFromEnumAndRecord(Object.values(HarCities), HarCitiesLabel)],
  [MarketCode.DFW, getOptionsFromEnumAndRecord(Object.values(DfwCities), DfwCitiesLabel)],
  [
    MarketCode.Amarillo,
    getOptionsFromEnumAndRecord(Object.values(AmarilloCities), AmarilloCitiesLabel)
  ]
]);
